<template>
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <rect width="20" height="20" fill="url(#pattern0)" />
    <defs>
      <pattern
        id="pattern0"
        patternContentUnits="objectBoundingBox"
        width="1"
        height="1"
      >
        <use xlink:href="#image0_1463_4217" transform="scale(0.0208333)" />
      </pattern>
      <image
        id="image0_1463_4217"
        width="48"
        height="48"
        xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAACXBIWXMAAAsTAAALEwEAmpwYAAACX0lEQVR4nO1ZS04cMRCtnpH43SAaF7PJAnGVQHYs+IgbBDEJEpuuMstcIAkf8RMI7sBdEk4AbFgOIrJ7mLiZoXHbnjEd+kklzbTa7veqyuVqN0CNGv8TZANa6RoIXtW/K4YEBP8C5MfM6KhKIpI8+WqJSIaTr4QI2QDkw2ekD4dee4Mihnn+iWgCgn76R+KDnAGUnwHpK8zytrOpyqJIveZ5MAna3FPsnW8g6O7l3CxpujSWJSYH7+3PU0Qe6TwY8dyDy3pVOghQns8NoN8geA8EfXe3dAVgqelNHl9LIZXzubShI2jLKfBGAM+jTf4jLeY8XynyCoK2DAG7MNpSaXl/mfKJtGMM3KkW+bACIpAPJyAS+TACIpL3FxCZvJeAUKVyqan7poHeadQCMF0PUudb6VqZniegAP5hjLtw3qTQdw26TiD4qj9uVi445zxGE0DX/XFtOedEPpqAj18mAbnbG/Og/7tWG4whQHn8X/90ra/Ny4nsum4OL60XOPoKcKkCZgeLfN9Lp15EBqy4q0T/TkCFezV7AbGsw0ibL5AtRz58M2kJwctDyHZB8B9dnfTpQrputcNiDAE6aulKFgla1Lmv1oALMI6AcMBagGz4NVOxI9DybaY8gbFaiVDAdy9AGKdy6jRu7BHgA2Mv6ThMMIqDLUu05ZTe/PptOX0qP8nzo0XBx2MR0Vbk6cRYfzcgOtNuk6nQmW2B9grte30fKDKk/dz7ROb9DR9/JIB8ZtmghTfBpyH2ICWiA4Jvx0eebnqeD7iBqjxU77hajM/3gQJD7uhnOOd8jRrgg7/KVpwAOWhWCwAAAABJRU5ErkJggg=="
      />
    </defs>
  </svg>
</template>
